// removed by extract-text-webpack-plugin
module.exports = {"default":"xmI8D","xl":"_9MDSq","l":"i8moW","m":"Wh3A8","s":"_3gLb5","square":"Fgeow","wide":"_25Aap","imax":"IZleT","imaxfull":"_1w7tR","balk":"_3uqyk","lwide":"_18ech","portrait":"_3oqGL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Bild/Bild.scss
 ** module id = 431
 ** module chunks = 0
 **/